// gradient/secondary icon fill — Figma 8184:57510 / lot-of-cash export.

import type { ComponentType, SVGProps } from "react";
import * as React from "react";

const GRADIENT_STOPS: Array<{ offset: string; color: string }> = [
  { offset: "0.030303", color: "#FE634D" },
  { offset: "0.0707071", color: "#FE595F" },
  { offset: "0.111111", color: "#FB5170" },
  { offset: "0.151515", color: "#F74B81" },
  { offset: "0.191919", color: "#F14592" },
  { offset: "0.232323", color: "#E942A3" },
  { offset: "0.272727", color: "#E040B4" },
  { offset: "0.313131", color: "#D53FC3" },
  { offset: "0.353535", color: "#CE3CC9" },
  { offset: "0.393939", color: "#C739CF" },
  { offset: "0.434343", color: "#BF36D5" },
  { offset: "0.474747", color: "#B734DB" },
  { offset: "0.515152", color: "#AF32E0" },
  { offset: "0.555556", color: "#A62FE6" },
  { offset: "0.59596", color: "#9D2DEA" },
  { offset: "0.636364", color: "#942AEF" },
  { offset: "0.676768", color: "#8A28F3" },
  { offset: "0.717172", color: "#8125F6" },
  { offset: "0.757576", color: "#7623F9" },
  { offset: "0.79798", color: "#6B20FC" },
  { offset: "0.838384", color: "#5F1FFE" },
  { offset: "0.878788", color: "#511DFF" },
  { offset: "0.919192", color: "#411DFF" },
  { offset: "0.959596", color: "#2E1DFF" },
  { offset: "1", color: "#001EFF" },
];

/** Figma export — filled gradient/secondary path (5299:18156 active card). */
export const BENEFIT_SALARY_ACTIVE_ICON_SRC =
  "/assets-next/careers/benefits/lot-of-cash.svg";

function BenefitIconGradientDefs({ id }: { id: string }) {
  return (
    <svg aria-hidden className="absolute size-0 overflow-hidden">
      <defs>
        <linearGradient
          id={id}
          x1="22.6997"
          y1="20.75"
          x2="-2.01434"
          y2="16.5389"
          gradientUnits="userSpaceOnUse"
        >
          {GRADIENT_STOPS.map((stop) => (
            <stop
              key={stop.offset}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      </defs>
    </svg>
  );
}

export function BenefitIcon({
  icon: Icon,
  isActive,
  variant,
}: {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  isActive: boolean;
  variant:
    | "salary"
    | "vacation"
    | "working"
    | "growth"
    | "benefits"
    | "colleagues";
}) {
  const gradientId = React.useId();

  if (!isActive) {
    return (
      <Icon
        aria-hidden
        className="text-grey-950 size-6 transition-colors duration-500 ease-out motion-reduce:transition-none"
        strokeWidth={1.5}
      />
    );
  }

  if (variant === "salary") {
    return (
      // eslint-disable-next-line @next/next/no-img-element
      <img
        src={BENEFIT_SALARY_ACTIVE_ICON_SRC}
        alt=""
        aria-hidden
        className="size-6 transition-opacity duration-500 ease-out motion-reduce:transition-none"
      />
    );
  }

  // Iconoir paths hardcode stroke="currentColor" — apply gradient via CSS on paths.
  return (
    <span
      className="inline-flex size-6 [&_path]:stroke-[var(--benefit-icon-gradient)]"
      style={
        {
          "--benefit-icon-gradient": `url(#${gradientId})`,
        } as React.CSSProperties
      }
    >
      <BenefitIconGradientDefs id={gradientId} />
      <Icon
        aria-hidden
        className="size-6 transition-[stroke] duration-500 ease-out motion-reduce:transition-none"
        strokeWidth={1.5}
      />
    </span>
  );
}
